export default __webpack_public_path__ + "static/media/epi3Vid.284907b4.jpg";